<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="loading || processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar :class="$style['container-header']">
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
      </template>
    </ToolBar>
    <div :class="$style['container-content']">
      <AppNavigation />
      <v-content class="app-content">
        <div :class="$style['main-content']">
          <template v-if="loaded">
            <template v-if="error">
              <div :class="$style['container-error']">
                <p>
                  <v-icon color="red darken-2">mdi-alert-circle</v-icon>
                  <span>エラーが発生しました</span>
                </p>
                <v-btn @click="onBack">戻る</v-btn>
              </div>
            </template>
            <template v-else>
              <div :class="$style['comments']">{{ comments }}</div>
              <MyForm
                :formKey="'base-form'"
                :entity="entity"
                :input="input"
                ref="form"
              >
                <FieldGenerator
                  v-for="(field, index) in fields"
                  :key="index"
                  :value="entity[field.name]"
                  :type="field.type || 'display'"
                  :name="field.name"
                  :label="field.label"
                  :render="field.render || undefined"
                  :as="field.as"
                  :option="(value) => field.option(value, entity)"
                  :remarks="field.remarks"
                >
                  <template v-if="field.type === 'custom'" :slot="field.name">
                    <slot :name="field.name" :input="entity[field.name]" />
                  </template>
                </FieldGenerator>
              </MyForm>
            </template>
          </template>
        </div>
        <div v-if="loaded && !error" :class="$style['container-footer']">
          <v-toolbar>
            <v-btn class="mx-1" color="primary" @click="onEdit">
              <v-icon left>mdi-update</v-icon>更新
            </v-btn>
            <v-btn class="mx-1" @click="backToEdit">
              <v-icon left>mdi-backup-restore</v-icon>戻る
            </v-btn>
          </v-toolbar>
        </div>
      </v-content>
    </div>
  </v-container>
</template>

<script>
import MyForm from "@/components/form";
import FieldGenerator from "@/components/field/generator";
import ToolBar from "@/components/app/toolbar";
import Breadcrumb from "@/components/app/breadcrumb";
import utility from "@/utility";

export default {
  components: {
    MyForm,
    FieldGenerator,
    ToolBar,
    Breadcrumb
  },
  props: {
    resourceName: {
      type: String,
      required: true
    },
    basePath: {
      type: String,
      defalut: ""
    },
    fields: {
      type: Array,
      required: true
    },
    pk: {
      type: String,
      required: true
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      input: {},
      comments: "以下の内容でよろしいですか"
    };
  },
  computed: {
    entity() {
      return this.$store.getters[`${this.resourceName}/entity/entity`];
    },
    loading() {
      return this.$store.getters[`${this.resourceName}/entity/isLoading`];
    },
    loaded() {
      return this.$store.getters[`${this.resourceName}/entity/isLoaded`];
    },
    processing() {
      return this.$store.getters[`${this.resourceName}/entity/isProcessing`];
    },
    error() {
      return this.$store.getters[`${this.resourceName}/entity/error`];
    },
    errorMessages() {
      return (
        this.$store.getters[`${this.resourceName}/entity/errorMessages`] || []
      );
    },
    computedBasePath() {
      return this.basePath || this.resourceName;
    },
    isDelivered() {
      return +this.entity.mail_delivered === 1;
    }
  },
  methods: {
    onEdit() {
      this.doUpdate();
    },
    doUpdate() {
      this.$store
        .dispatch(`${this.resourceName}/entity/update`, {
          pk: this.pk,
          updatedEntity: this.entity
        })
        .then(() => {
          this.$router.push({ name: this.resourceName });
        })
        .catch(() => {
          if (this.$refs.form) {
            this.$refs.form.setErrors(this.errorMessages);
          }
        });
    },
    backToEdit() {
      this.$store
        .dispatch(`${this.resourceName}/entity/backFromConfirm`)
        .then(() => {
          this.$router.push({
            path: `/${this.resourceName}/${this.pk}/edit`
          });
        });
    },
    onBack() {
      this.$router.push({ path: `/${this.resourceName}` });
    }
  }
};
</script>

<style module lang="scss">
$base-app-header-height: 70px;
$base-header-height: 50px;
$base-footer-height: 64px;

.container.container {
  width: 100%;
  height: calc(100% - #{$base-app-header-height});
  padding: 0;

  .container-header {
    height: $base-header-height !important;
  }

  .container-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: calc(100% - #{$base-header-height});
    overflow: hidden;

    .main-content {
      height: calc(
        100vh - #{$base-header-height} - #{$base-footer-height} - #{$base-app-header-height}
      );
      padding: 8px;
      overflow-y: auto;
      overflow-x: hidden;

      .comments {
        padding: 0 16px;
        font-size: 14px;
        margin-bottom: 8px;
      }
    }
  }

  .container-error {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    p {
      color: #ff0000;
      i {
        margin: 0 10px 0 0;
      }
      i,
      span {
        vertical-align: middle;
      }
    }
  }

  .container-footer {
    height: $base-footer-height !important;
  }
}
</style>
